import { defineMessages } from "react-intl";

export const messages = defineMessages({
    requiredMessages: {
        id: "validation.mesages.required",
        defaultMessage: "The {column} field is required.",
    },
    minLengthMessages: {
        id: "validation.mesages.min_length",
        defaultMessage: "The {column} must be at least {min} characters long.",
    },
    maxLengthMessages: {
        id: "validation.mesages.max_length",
        defaultMessage: "The {column} may not be greater than {max} characters long.",
    },
    emailMessages: {
        id: "validation.mesages.email",
        defaultMessage: "The {column} must be a valid email.",
    },
    minMessages: {
        id: "validation.mesages.min",
        defaultMessage: "The {column} must be at least {min}.",
    },
    maxMessages: {
        id: "validation.mesages.max",
        defaultMessage: "The {column} may not be greater than {max}.",
    },
    patternMessages: {
        id: "validation.mesages.pattern",
        defaultMessage: "The {column} must match the pattern {pattern}.",
    },
    equalToMessages: {
        id: "validation.mesages.equal_to",
        defaultMessage: "The {column} must match {match}.",
    },
    oneOfMessages: {
        id: "validation.mesages.one_of",
        defaultMessage: "The {column} must be one of {matches}.",
    },
    urlMessages: {
        id: "validation.mesages.url",
        defaultMessage: "The {column} is not a valid URL.",
    },
});
